import { createBrowserRouter, createHashRouter } from "react-router-dom"

import GuestRoute from "routes/middleware/guest"
import ProtectedRoute from "routes/middleware/protected"

import Dashboard from "pages/dashboard"
import Approve from "pages/approval/approve"
import Submitted from "pages/approval/submitted"
import Login from "pages/auth/login"
import Register from "pages/auth/register"
import NoRole from "pages/no-role"
import { show as showDashboard } from "./loader/dashboard"
import { load as loadMainData } from "./loader/main"
import { loadAutoRedirect as loadAutoRedirectApproval } from "./loader/approval"
import { load as loadApproval } from "./loader/approval"

import { show as showBrand } from "./loader/brand"
import { show as showSatuan } from "./loader/satuan"
import { show as showSeries } from "./loader/series"
import { show as showAttributeGroup } from "./loader/attribute-group"
import { show as showAttribute } from "./loader/attribute"
import { show as showTag } from "./loader/product_tag"
import { show as showProductNeed } from "./loader/product-need"
import { show as showProductFamily } from "./loader/product-family"
import { show as showProductClass } from "./loader/product-class"
import { show as showProductLine } from "./loader/product-line"
import { show as showProductType } from "./loader/product-type"
import { show as showProductBrand } from "./loader/product-brand"
import { show as showProductSeries } from "./loader/product-series"
import { show as showProductModel } from "./loader/product-model"
import { show as showProductUnit } from "./loader/product-unit"
import { show as showProductSupplier } from "./loader/product-supplier"
import { show as showProductSimilar } from "./loader/product-similar"
import { show as showDiscount } from "./loader/discount"
import { show as showReward } from "./loader/reward"
import { show as showPurchaseTransaction } from "./loader/purchase-transaction"
import { show as showGoodsReceiptTransaction } from "./loader/goods-receipt"
import { show as showReturnTransaction } from "./loader/return-transaction"

import { getByUser as getBranchByUser } from "./loader/branch"
import SelectBranch from "pages/select-branch"
import { lang } from "config"
import AlreadySubmitted from "pages/approval/already-submitted"
import Error from "pages/error"
import { List as BrandList, Create as CreateBrand, Edit as EditBrand } from "pages/brand"
import { List as SatuanList, Create as CreateSatuan, Edit as EditSatuan } from "pages/satuan"
import { List as SeriesList, Create as CreateSeries, Edit as EditSeries } from "pages/series"
import { List as AttributeList, Create as CreateAttribute, Edit as EditAttribute } from "pages/attribute"
import { List as BankTransferVerificationList } from "pages/bank-transfer-verification"
import { List as TagList, Create as CreateTag, Edit as EditTag } from "pages/product_tag"
import { List as AttributeGroupList, Create as CreateAttributeGroup, Edit as EditAttributeGroup } from "pages/attribute/group"
import { List as ProductNeedList, Create as CreateProductNeed, Edit as EditProductNeed } from "pages/product/need"
import { List as ProductFamilyList, Create as CreateProductFamily, Edit as EditProductFamily } from "pages/product/family"
import { List as ProductClassList, Create as CreateProductClass, Edit as EditProductClass } from "pages/product/class"
import { List as ProductLineList, Create as CreateProductLine, Edit as EditProductLine } from "pages/product/line"
import { List as ProductTypeList, Create as CreateProductType, Edit as EditProductType } from "pages/product/type"
import { List as ProductTypeGroupList } from "pages/product/type-group"
import { List as ProductBrandList, Create as CreateProductBrand, Edit as EditProductBrand } from "pages/product/brand"
import { List as ProductSeriesList, Create as CreateProductSeries, Edit as EditProductSeries } from "pages/product/series"
import { List as ProductModelList, Create as CreateProductModel, Edit as EditProductModel } from "pages/product/model"
import { List as ProductUnitList, Create as CreateProductUnit, Edit as EditProductUnit } from "pages/product/unit"
import { List as ProductSupplierList, Create as CreateProductSupplier, Edit as EditProductSupplier } from "pages/product/supplier"
import { List as ProductStockList, } from "pages/product/stock"
import { List as ProductSimilarList, Create as CreateProductSimilar, Edit as EditProductSimilar } from "pages/product/similar"
import LegacySalesImport from "pages/legacy-sales-import"
import MasterStockYearlyImport from "pages/master-stock-yearly-import"
import { List as ProductMapList, Create as CreateProductUnitBranchMap } from "pages/product/map"
import { List as ProductUnitExclusivityList, Create as CreateProductUnitExclusivity } from "pages/product-exclusivity"
import { List as DiscountList, Create as CreateDiscount, Edit as EditDiscount, Apply as ApplyDiscount } from "pages/discount"
import { List as RewardList, Create as CreateReward, Edit as EditReward } from "pages/reward"
import { List as StockTransferList, Create as CreateStockTransfer, Edit as EditStockTransfer } from "pages/stock-transfer"
import { List as StockMovementList } from "pages/stock-movement"
import { List as StockAdjustmentList, Form as StockAdjustmentForm } from "pages/stock-adjustment"
import { List as StockOpnameList, Form as StockOpnameForm, CheckForm as StockOpnameCheckForm, Variance as StockOpnameVariance } from "pages/stock-opname"
import { List as StockCardList } from "pages/stock-card"
import { List as StockBalanceList } from "pages/store-balance"
import { List as EndOfMonthList } from "pages/report/end-of-month"
import { List as SalesAmountYearlyReportList } from "pages/report/sales-amount-yearly"
import { List as ConsignmentSalesYearlyReportList } from "pages/report/consignment-sales-yearly"
import { List as SalesGroupReportList } from "pages/report/sales-group"
import { List as MasterStockGlobalReportList } from "pages/report/master-stock-global"
import { List as MasterStockDetailReportList } from "pages/report/master-stock-detail"
import { List as MasterStockValueGlobalReportList } from "pages/report/master-stock-value-global"
import { List as MasterStockValueDetailReportList } from "pages/report/master-stock-value-detail"
import { List as SalesDateSummaryReportList } from "pages/report/sales-date-summary"
import { List as PurchaseReturnReportList } from "pages/report/purchase-return"
import { List as PurchaseReportList } from "pages/report/purchase"
import { List as OutstandingPoReportList } from "pages/report/outstanding-po"
// ATALLA-359: Laporan Pembelian Intercompany di-unlink dari menu & route (file dipertahankan).
// import { List as IntercompanyPurchaseReportList } from "pages/report/intercompany-purchase"
// ATALLA-383: Laporan Penjualan Antar Toko (PT Atalla/Vision cek penjualan produknya lintas outlet).
import { List as IntercompanySalesReportList } from "pages/report/intercompany-sales"
import { List as TopTenSoldItemsReportList } from "pages/report/top-ten-sold-items"
import { List as TransactionReportList } from "pages/report/transaction-report"
import { List as GoodsReceiptIncomingReportList } from "pages/report/goods-receipt-incoming"
import { List as StockAdjustmentCorrectionReportList } from "pages/report/stock-adjustment-correction"
import { List as StockVarianceReportList } from "pages/report/stock-variance"
import { List as CustomerCardReportList } from "pages/report/customer-card-report"
import { List as ConfirmedOrderReportList } from "pages/report/confirmed-order-report"
import { List as CustomerNoteReportList } from "pages/report/customer-note-report"
import { List as CustomerNoteMutationReportList } from "pages/report/customer-note-mutation"
import { List as CustomerDebtReportList } from "pages/report/customer-debt-report"
import { List as StockBelowMinimumList } from "pages/report/stock-below-minimum"
import { List as SalesQtyYearlyReportList } from "pages/report/sales-qty-yearly"
import { List as EndOfDayReportList } from "pages/report/end-of-day"
import { List as PurchaseList, Create as CreatePurchase, Edit as EditPurchase } from "pages/purchase"
import { List as HoOrderList, Create as CreateHoOrder, Edit as EditHoOrder } from "pages/ho-order"
import { List as SuratJalanUmumList, Create as CreateSuratJalanUmum, Edit as EditSuratJalanUmum } from "pages/surat-jalan-umum"
import { List as FakturUmumList, Create as CreateFakturUmum, Edit as EditFakturUmum } from "pages/faktur-umum"
import { List as MasterHargaList } from "pages/master-harga"
import { List as MasterCustomerList } from "pages/master-customer"
// 270726: master pasangan outlet ↔ customer HO (dasar pencatatan hutang toko).
import { List as OutletCustomerMappingList } from "pages/outlet-customer-mapping"
import { List as ProductUnitDiscountList } from "pages/product-unit-discount"
import { List as GoodsReceiptList, Edit as EditGoodsReceipt } from "pages/goods-receipt"
import { List as CustomerNotesList } from "pages/customer-notes"
import { List as ReturnList, Create as CreateReturn, Edit as EditReturn } from "pages/return"
import { List as OfflineReturnList, Create as CreateOfflineReturn, Edit as EditOfflineReturn } from "pages/offline-return"
import ApprovalList from "pages/approval/list"

import AppLayout from "layouts/app-layout"
import { Form as ProductWizardForm } from "pages/product/wizard"
import Settings from "pages/settings"
import { Form as FormBarcode } from "pages/barcode"
import App from "App"

export const routeList = [
    // Root loader
    {
        loader: loadMainData,
        errorElement: <Error />,
        children: [
            // Guest
            {
                path: "/register",
                element: (
                    <GuestRoute>
                        <Register title={lang.title.sign_up} />
                    </GuestRoute>
                )
            },
            {
                path: "/login",
                element: (
                    <GuestRoute>
                        <Login title={lang.title.sign_in} />
                    </GuestRoute>
                )
            },

            // Protected
            {
                path: "/branch/select",
                element: (
                    <ProtectedRoute>
                        <SelectBranch title={lang.title.select_branch} />
                    </ProtectedRoute>
                ),
                loader: getBranchByUser
            },
            {
                path: "/approve/:number",
                key: 'approve',
                element: (
                    <ProtectedRoute needToHaveRole={false} needToSelectBranch={false}>
                        <Approve />
                    </ProtectedRoute>
                ),
                loader: loadAutoRedirectApproval
            },
            {
                path: "/approve/:number/submitted",
                element: (
                    <ProtectedRoute needToHaveRole={false} needToSelectBranch={false}>
                        <Submitted title="Approval Submitted" />
                    </ProtectedRoute>
                )
            },
            {
                path: "/approve/:number/already",
                element: (
                    <ProtectedRoute needToHaveRole={false} needToSelectBranch={false}>
                        <AlreadySubmitted title="Approval Already Submitted" />
                    </ProtectedRoute>
                ),
                loader: loadApproval
            },
            {
                path: "/no-role",
                element: (
                    <ProtectedRoute>
                        <NoRole title="No Role Assigned" />
                    </ProtectedRoute>
                )
            },

            // Protected, App Layout
            {
                middleware: "protected",
                element: (
                    <ProtectedRoute>
                        <AppLayout />
                    </ProtectedRoute>
                ),
                children: [
                    {
                        path: "/",
                        index: true,
                        title: "Dashboard",
                        element: (
                            <Dashboard />
                        ),
                        // loader: showDashboard
                    },
                    {
                        path: "/approvals",
                        index: true,
                        title: "Approvals",
                        element: (
                            <ApprovalList />
                        ),
                        // loader: showDashboard
                    },
                    {
                        path: "/settings",
                        title: "Settings",
                        element: (
                            <Settings />
                        )
                    },
                    {
                        path: "/brand",
                        title: "Brand",
                        element: (
                            <BrandList key="/brand" />
                        )
                    },
                    {
                        path: "/brand/create",
                        title: "Tambah Brand",
                        element: (
                            <CreateBrand key="/brand/create" title="Create Brand" />
                        )
                    },
                    {
                        path: "/brand/:id/edit",
                        element: (
                            <EditBrand />
                        ),
                        loader: showBrand
                    },
                    {
                        path: "/satuan",
                        title: "Satuan",
                        element: (
                            <SatuanList key="/satuan" />
                        )
                    },
                    {
                        path: "/satuan/create",
                        title: "Tambah Satuan",
                        element: (
                            <CreateSatuan key="/satuan/create" title="Create Satuan" />
                        )
                    },
                    {
                        path: "/satuan/:id/edit",
                        element: (
                            <EditSatuan />
                        ),
                        loader: showSatuan
                    },
                    {
                        path: "/brand/series",
                        title: "Series",
                        element: (
                            <SeriesList key="/brand/series" />
                        )
                    },
                    {
                        path: "/brand/series/create",
                        title: "Tambah Series",
                        element: (
                            <CreateSeries key="/brand/series" />
                        )
                    },
                    {
                        path: "/brand/series/:id/edit",
                        element: (
                            <EditSeries />
                        ),
                        loader: showSeries
                    },
                    {
                        path: "/attribute",
                        title: "Atribut",
                        element: (
                            <AttributeList key="/attribute" />
                        )
                    },
                    {
                        path: "/attribute/create",
                        title: "Tambah Atribut",
                        element: (
                            <CreateAttribute key="/attribute/create" />
                        )
                    },
                    {
                        path: "/attribute/:id/edit",
                        element: (
                            <EditAttribute />
                        ),
                        loader: showAttribute
                    },
                    {
                        path: "/attribute/group",
                        title: "Grup Atribut",
                        element: (
                            <AttributeGroupList key="/attribute/group" />
                        )
                    },
                    {
                        path: "/attribute/group/create",
                        title: "Tambah Grup Atribut",
                        element: (
                            <CreateAttributeGroup key="/attribute/group/create" />
                        )
                    },
                    {
                        path: "/attribute/group/:id/edit",
                        title: "Tambah Grup Atribut",
                        element: (
                            <EditAttributeGroup />
                        ),
                        loader: showAttributeGroup
                    },
                    {
                        path: "/tag",
                        title: "Tag",
                        element: (
                            <TagList key="/tag" />
                        )
                    },
                    {
                        path: "/tag/create",
                        title: "Tambah Tag",
                        element: (
                            <CreateTag key="/tag/create" />
                        )
                    },
                    {
                        path: "/tag/:id/edit",
                        element: (
                            <EditTag />
                        ),
                        loader: showTag
                    },
                    {
                        path: "/product/need",
                        title: "Kebutuhan Produk",
                        element: (
                            <ProductNeedList />
                        )
                    },
                    {
                        path: "/product/need/create",
                        title: "Tambah Kebutuhan Produk",
                        element: (
                            <CreateProductNeed />
                        )
                    },
                    {
                        path: "/product/need/:id/edit",
                        element: (
                            <EditProductNeed />
                        ),
                        loader: showProductNeed
                    },
                    {
                        path: "/product/family",
                        title: "Family Produk",
                        element: (
                            <ProductFamilyList />
                        )
                    },
                    {
                        path: "/product/family/create",
                        title: "Tambah Family Produk",
                        element: (
                            <CreateProductFamily />
                        )
                    },
                    {
                        path: "/product/family/:id/edit",
                        element: (
                            <EditProductFamily />
                        ),
                        loader: showProductFamily
                    },
                    {
                        path: "/product/class",
                        title: "Class Produk",
                        element: (
                            <ProductClassList />
                        )
                    },
                    {
                        path: "/product/class/create",
                        title: "Tambah Class Produk",
                        element: (
                            <CreateProductClass />
                        )
                    },
                    {
                        path: "/product/class/:id/edit",
                        element: (
                            <EditProductClass />
                        ),
                        loader: showProductClass
                    },
                    {
                        path: "/product/line",
                        title: "Line Produk",
                        element: (
                            <ProductLineList />
                        )
                    },
                    {
                        path: "/product/line/create",
                        title: "Tambah Line Produk",
                        element: (
                            <CreateProductLine />
                        )
                    },
                    {
                        path: "/product/line/:id/edit",
                        element: (
                            <EditProductLine />
                        ),
                        loader: showProductLine
                    },
                    {
                        path: "/product/type",
                        title: "Type Produk",
                        element: (
                            <ProductTypeList />
                        )
                    },
                    {
                        path: "/product/type-group",
                        title: "Grup Type Produk",
                        element: (
                            <ProductTypeGroupList />
                        )
                    },
                    {
                        path: "/product/type/create",
                        title: "Tambah Type Produk",
                        element: (
                            <CreateProductType />
                        )
                    },
                    {
                        path: "/product/type/:id/edit",
                        element: (
                            <EditProductType />
                        ),
                        loader: showProductType
                    },
                    {
                        path: "/product/brand",
                        title: "Brand Produk",
                        element: (
                            <ProductBrandList />
                        )
                    },
                    {
                        path: "/product/brand/create",
                        title: "Tambah Brand Produk",
                        element: (
                            <CreateProductBrand />
                        )
                    },
                    {
                        path: "/product/brand/:id/edit",
                        element: (
                            <EditProductBrand />
                        ),
                        loader: showProductBrand
                    },
                    {
                        path: "/product/series",
                        title: "Series Produk",
                        element: (
                            <ProductSeriesList />
                        )
                    },
                    {
                        path: "/product/series/create",
                        title: "Tambah Series Produk",
                        element: (
                            <CreateProductSeries />
                        )
                    },
                    {
                        path: "/product/series/:id/edit",
                        element: (
                            <EditProductSeries />
                        ),
                        loader: showProductSeries
                    },
                    {
                        path: "/product/model",
                        title: "Model Produk",
                        element: (
                            <ProductModelList />
                        )
                    },
                    {
                        path: "/product/model/create",
                        title: "Tambah Model Produk",
                        element: (
                            <CreateProductModel />
                        )
                    },
                    {
                        path: "/product/model/:id/edit",
                        element: (
                            <EditProductModel />
                        ),
                        loader: showProductModel
                    },
                    {
                        path: "/product/unit",
                        title: "Unit Produk",
                        element: (
                            <ProductUnitList />
                        )
                    },
                    {
                        path: "/product/unit/create",
                        title: "Tambah Unit Produk",
                        element: (
                            <CreateProductUnit />
                        )
                    },
                    {
                        path: "/product/unit/:id/edit",
                        element: (
                            <EditProductUnit />
                        ),
                        loader: showProductUnit
                    },
                    {
                        path: "/product/supplier",
                        title: "Supplier Produk",
                        element: (
                            <ProductSupplierList />
                        )
                    },
                    {
                        path: "/product/stock",
                        title: "Stok Produk",
                        element: (
                            <ProductStockList />
                        )
                    },
                    {
                        path: "/tools/legacy-sales-import",
                        title: "Migrasi Penjualan Setahun",
                        element: (
                            <LegacySalesImport />
                        )
                    },
                    {
                        path: "/tools/master-stock-yearly-import",
                        title: "Import Pergerakan Stok Setahun",
                        element: (
                            <MasterStockYearlyImport />
                        )
                    },
                    {
                        path: "/product/supplier/create",
                        title: "Tambah Supplier Produk",
                        element: (
                            <CreateProductSupplier />
                        )
                    },
                    {
                        path: "/product/supplier/:id/edit",
                        element: (
                            <EditProductSupplier />
                        ),
                        loader: showProductSupplier
                    },
                    {
                        path: "/product/wizard",
                        title: "Produk Baru",
                        element: (
                            <ProductWizardForm key="/product/wizard" title="Product Wizard" />
                        )
                    },
                    {
                        path: "/customer-notes",
                        title: "Catatan Customer",
                        element: (
                            <CustomerNotesList />
                        )
                    },
                    // {
                    //     path: "/product/wizard",
                    //     title: "Product Wizard",
                    //     element: (
                    //         <CreateProductUnit />
                    //     )
                    // },
                    {
                        path: "/product/map",
                        title: "Map Unit Produk per Cabang",
                        element: (
                            <ProductMapList />
                        )
                    },
                    {
                        path: "/product/map/create",
                        title: "Tambah Map Unit Produk per Cabang",
                        element: (
                            <CreateProductUnitBranchMap />
                        )
                    },
                    {
                        path: "/exclusivity",
                        title: "Eksklusivitas Unit Produk",
                        element: (
                            <ProductUnitExclusivityList />
                        )
                    },
                    {
                        path: "/exclusivity/create",
                        title: "Tambah Eksklusivitas Unit Produk",
                        element: (
                            <CreateProductUnitExclusivity />
                        )
                    },
                    {
                        path: "/ho-order",
                        title: "Order HO ke Customer",
                        element: (
                            <HoOrderList />
                        )
                    },
                    {
                        path: "/ho-order/create",
                        title: "Buat Order HO ke Customer",
                        element: (
                            <CreateHoOrder />
                        )
                    },
                    {
                        // 230726 (permintaan user): edit order HO REJECTED.
                        path: "/ho-order/:id/edit",
                        title: "Edit Order HO ke Customer",
                        element: (
                            <EditHoOrder />
                        )
                    },
                    {
                        path: "/bank-transfer-verification",
                        title: "Verifikasi Transfer Bank",
                        element: (
                            <BankTransferVerificationList />
                        )
                    },
                    {
                        path: "/product/similar",
                        title: "Produk Serupa",
                        element: (
                            <ProductSimilarList />
                        )
                    },
                    {
                        path: "/product/similar/create",
                        title: "Atur Produk Serupa",
                        element: (
                            <CreateProductSimilar />
                        )
                    },
                    {
                        path: "/product/similar/:id/edit",
                        element: (
                            <EditProductSimilar />
                        ),
                        loader: showProductSimilar
                    },
                    {
                        path: "/discount",
                        title: "Diskon",
                        element: (
                            <DiscountList />
                        )
                    },
                    {
                        path: "/discount/create",
                        title: "Tambah Diskon",
                        element: (
                            <CreateDiscount />
                        )
                    },
                    {
                        path: "/discount/apply",
                        title: "Terapkan Diskon",
                        element: (
                            <ApplyDiscount />
                        )
                    },
                    {
                        path: "/discount/:id/edit",
                        element: (
                            <EditDiscount />
                        ),
                        loader: showDiscount
                    },
                    {
                        path: "/reward",
                        title: "Reward",
                        element: (
                            <RewardList />
                        )
                    },
                    {
                        path: "/reward/create",
                        title: "Tambah Reward",
                        element: (
                            <CreateReward />
                        )
                    },
                    {
                        path: "/reward/:id/edit",
                        element: (
                            <EditReward />
                        ),
                        loader: showReward
                    },
                    {
                        path: "/stock-movement",
                        title: "Pergerakan Stok",
                        element: (
                            <StockMovementList />
                        )
                    },
                    {
                        path: "/stock-transfer",
                        title: "Transfer Stok",
                        element: (
                            <StockTransferList />
                        )
                    },
                    {
                        path: "/stock-adjustment",
                        title: "Stock Adjustment",
                        element: (
                            <StockAdjustmentList />
                        )
                    },
                    {
                        path: "/stock-adjustment/create",
                        title: "Tambah Stock Adjustment",
                        element: (
                            <StockAdjustmentForm />
                        )
                    },
                    {
                        path: "/stock-adjustment/:id/edit",
                        title: "Edit Stock Adjustment",
                        element: (
                            <StockAdjustmentForm />
                        )
                    },
                    {
                        path: "/stock-opname",
                        title: "Stock Opname",
                        element: (
                            <StockOpnameList />
                        )
                    },
                    {
                        path: "/stock-opname/:id",
                        title: "Stock Opname",
                        element: (
                            <StockOpnameForm />
                        )
                    },
                    {
                        path: "/stock-opname/:id/variance",
                        title: "Cek Selisih Stock Opname",
                        element: (
                            <StockOpnameVariance />
                        )
                    },
                    {
                        path: "/stock-opname/:id/checks/:checkId",
                        title: "Cek Stock",
                        element: (
                            <StockOpnameCheckForm />
                        )
                    },
                    {
                        path: "/stock-balance",
                        title: "Stock Real",
                        element: (
                            <StockBalanceList />
                        )
                    },
                    {
                        path: "/stock-card",
                        title: "Kartu Stock",
                        element: (
                            <StockCardList />
                        )
                    },
                    {
                        path: "/store-balance",
                        title: "Akhir Bulan",
                        element: (
                            <EndOfMonthList />
                        )
                    },
                    {
                        path: "/reports/end-of-month",
                        title: "Laporan Akhir Bulan",
                        element: (
                            <EndOfMonthList />
                        )
                    },
                    {
                        path: "/reports/end-of-day",
                        title: "Laporan Akhir Hari",
                        element: (
                            <EndOfDayReportList />
                        )
                    },
                    {
                        path: "/reports/sales-amount-yearly",
                        title: "Laporan Nominal Penjualan Tahunan",
                        element: (
                            <SalesAmountYearlyReportList />
                        )
                    },
                    {
                        path: "/reports/consignment-sales-yearly",
                        title: "Rekap Penjualan Konsinyasi",
                        element: (
                            <ConsignmentSalesYearlyReportList />
                        )
                    },
                    {
                        path: "/reports/sales-group",
                        title: "Laporan Penjualan Group",
                        element: (
                            <SalesGroupReportList />
                        )
                    },
                    {
                        path: "/reports/intercompany-sales",
                        title: "Penjualan Antar Toko",
                        element: (
                            <IntercompanySalesReportList />
                        )
                    },
                    {
                        path: "/reports/master-stock-global",
                        title: "Master Barang Global",
                        element: (
                            <MasterStockGlobalReportList />
                        )
                    },
                    {
                        path: "/reports/master-stock-detail",
                        title: "Master Barang Detail",
                        element: (
                            <MasterStockDetailReportList />
                        )
                    },
                    {
                        path: "/reports/master-stock-value-global",
                        title: "Nilai Stock Barang Global",
                        element: (
                            <MasterStockValueGlobalReportList />
                        )
                    },
                    {
                        path: "/reports/master-stock-value-detail",
                        title: "Nilai Stock Barang Detail",
                        element: (
                            <MasterStockValueDetailReportList />
                        )
                    },
                    {
                        path: "/reports/sales-date-summary",
                        title: "Laporan Ringkasan Penjualan",
                        element: (
                            <SalesDateSummaryReportList />
                        )
                    },
                    {
                        path: "/reports/top-ten-sold-items",
                        title: "Laporan Top 10 Barang Terjual",
                        element: (
                            <TopTenSoldItemsReportList />
                        )
                    },
                    {
                        path: "/reports/transaction-report",
                        title: "Laporan Transaksi",
                        element: (
                            <TransactionReportList />
                        )
                    },
                    {
                        path: "/reports/goods-receipt-incoming",
                        title: "Laporan Barang Masuk",
                        element: (
                            <GoodsReceiptIncomingReportList />
                        )
                    },
                    {
                        path: "/reports/purchase-return",
                        title: "Laporan Retur Supplier",
                        element: (
                            <PurchaseReturnReportList />
                        )
                    },
                    {
                        path: "/reports/purchase",
                        title: "Laporan Pembelian",
                        element: (
                            <PurchaseReportList />
                        )
                    },
                    {
                        path: "/reports/outstanding-po",
                        title: "Laporan Sisa PO",
                        element: (
                            <OutstandingPoReportList />
                        )
                    },
                    {
                        path: "/reports/stock-adjustment-correction",
                        title: "Laporan Koreksi Stock",
                        element: (
                            <StockAdjustmentCorrectionReportList />
                        )
                    },
                    {
                        path: "/reports/stock-variance",
                        title: "Laporan Selisih Fisik / Computer",
                        element: (
                            <StockVarianceReportList />
                        )
                    },
                    {
                        path: "/reports/customer-card-report",
                        title: "Kartu Customer",
                        element: (
                            <CustomerCardReportList />
                        )
                    },
                    {
                        path: "/reports/confirmed-order-report",
                        title: "Faktur Belum Lunas",
                        element: (
                            <ConfirmedOrderReportList />
                        )
                    },
                    {
                        path: "/reports/customer-note-report",
                        title: "Laporan Credit Note / Debit Note",
                        element: (
                            <CustomerNoteReportList />
                        )
                    },
                    {
                        path: "/reports/customer-note-mutation",
                        title: "Mutasi Customer",
                        element: (
                            <CustomerNoteMutationReportList />
                        )
                    },
                    {
                        path: "/reports/customer-debt-report",
                        title: "Laporan Sisa Hutang Customer",
                        element: (
                            <CustomerDebtReportList />
                        )
                    },
                    {
                        path: "/reports/stock-below-minimum",
                        title: "Laporan Stock di Bawah Minimum",
                        element: (
                            <StockBelowMinimumList />
                        )
                    },
                    {
                        path: "/reports/sales-qty-yearly",
                        title: "Laporan Qty Penjualan Tahunan",
                        element: (
                            <SalesQtyYearlyReportList />
                        )
                    },
                    {
                        path: "/stock-transfer/create",
                        title: "Tambah Transfer Stok",
                        element: (
                            <CreateStockTransfer />
                        )
                    },
                    {
                        path: "/stock-transfer/:id/edit",
                        title: "Lanjutkan Draft Transfer Stok",
                        element: (
                            <EditStockTransfer />
                        )
                    },
                    {
                        path: "/purchase",
                        title: "Pembelian",
                        element: (
                            <PurchaseList />
                        )
                    },
                    {
                        path: "/purchase/create",
                        title: "Tambah Pembelian",
                        element: (
                            <CreatePurchase />
                        )
                    },
                    {
                        path: "/purchase/:id/create",
                        title: "Tambah Pembelian",
                        element: (
                            <CreatePurchase />
                        ),
                        loader: showPurchaseTransaction
                    },
                    {
                        path: "/purchase/:id/edit",
                        title: "Edit Pembelian",
                        element: (
                            <EditPurchase />
                        ),
                        loader: showPurchaseTransaction
                    },
                    {
                        path: "/surat-jalan-umum",
                        title: "Surat Jalan Umum",
                        element: (
                            <SuratJalanUmumList />
                        )
                    },
                    {
                        path: "/master-harga",
                        title: "Master Harga",
                        element: (
                            <MasterHargaList />
                        )
                    },
                    {
                        path: "/master-customer",
                        title: "Master Customer",
                        element: (
                            <MasterCustomerList />
                        )
                    },
                    {
                        path: "/outlet-customer-mapping",
                        title: "Customer Penagihan Outlet",
                        element: (
                            <OutletCustomerMappingList />
                        )
                    },
                    {
                        path: "/product-unit-discount",
                        title: "Diskon Product Unit",
                        element: (
                            <ProductUnitDiscountList />
                        )
                    },
                    {
                        path: "/surat-jalan-umum/create",
                        title: "Tambah Surat Jalan Umum",
                        element: (
                            <CreateSuratJalanUmum />
                        )
                    },
                    {
                        path: "/surat-jalan-umum/:id/edit",
                        title: "Edit Surat Jalan Umum",
                        element: (
                            <EditSuratJalanUmum />
                        )
                    },
                    {
                        path: "/faktur-umum",
                        title: "Faktur Umum",
                        element: (
                            <FakturUmumList />
                        )
                    },
                    {
                        path: "/faktur-umum/create",
                        title: "Tambah Faktur Umum",
                        element: (
                            <CreateFakturUmum />
                        )
                    },
                    {
                        path: "/faktur-umum/:id/edit",
                        title: "Edit Faktur Umum",
                        element: (
                            <EditFakturUmum />
                        )
                    },
                    {
                        path: "/goods-receipt",
                        title: "Penerimaan Barang",
                        element: (
                            <GoodsReceiptList />
                        )
                    },
                    {
                        path: "/goods-receipt/:id/edit",
                        title: "Edit Penerimaan Barang",
                        element: (
                            <EditGoodsReceipt />
                        ),
                        loader: showGoodsReceiptTransaction
                    },
                    {
                        path: "/barcode",
                        title: "Barcode",
                        element: (
                            <FormBarcode />
                        )
                    },
                    {
                        path: "/return",
                        title: "Retur",
                        element: (
                            <ReturnList />
                        )
                    },
                    {
                        path: "/return/create",
                        title: "Tambah Retur",
                        element: (
                            <CreateReturn />
                        )
                    },
                    {
                        path: "/return/:id/edit",
                        title: "Edit Retur",
                        element: (
                            <EditReturn />
                        ),
                        loader: showReturnTransaction
                    },
                    {
                        path: "/offline-return",
                        title: "Retur Toko Offline",
                        element: (
                            <OfflineReturnList />
                        )
                    },
                    {
                        path: "/offline-return/create",
                        title: "Buat Retur Toko Offline",
                        element: (
                            <CreateOfflineReturn />
                        )
                    },
                    {
                        path: "/offline-return/:id/edit",
                        title: "Edit Retur Toko Offline",
                        element: (
                            <EditOfflineReturn />
                        )
                    },
                ]
            }
        ]
    }
]

export const routes = process.env.NODE_ENV === 'development' ? createBrowserRouter(routeList) : createHashRouter(routeList)

export default routes
